const header = async function() {

    function handleHeaderScroll() {
        const header = document.querySelector('.header');

        if (header) {
            let oldScroll = window.scrollY;

            function updateHeader() {
                const top = window.scrollY;

                if (top > 150 && oldScroll < top) {
                    header.classList.add("scrolledDown");
                } else if (oldScroll > top) {
                    header.classList.remove("scrolledDown");
                }

                if (top < 30) {
                    header.classList.remove('bg-navy');
                } else {
                    header.classList.add('bg-navy');
                }

                oldScroll = top;
            }

            // Fire on page load
            updateHeader();

            // Attach event listener for scroll
            window.addEventListener("scroll", updateHeader);
        }
    }
    handleHeaderScroll();

}

export const init = header;